import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import locale from '@angular/common/locales/fr-BE';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClarityModule } from '@clr/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from './config/app-config';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { NotFoundModule } from './not-found/not-found.module';
import { BootstrapComponent } from './root.component';
import { AuthCognitoService } from './services/auth-cognito.service';
import { UserService } from './services/user.service';
import { SharedModule } from './shared/shared.module';
import { initializer } from './utils/app-init';
import { CdsIconModule } from '@cds/angular';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(locale);

@NgModule({
	declarations: [BootstrapComponent, AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		ClarityModule,
		NotFoundModule,
		SharedModule,
		BrowserAnimationsModule,
		ToastrModule.forRoot({
			timeOut: 4000,
			positionClass: 'toast-bottom-right'
		}),
		CdsIconModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			},
			defaultLanguage: 'en'
		})
	],
	providers: [
		JwtInterceptor,
		{ provide: LOCALE_ID, useValue: 'fr-BE' },
		{
			provide: APP_INITIALIZER,
			useFactory: initializer,
			multi: true,
			deps: [UserService, AppConfig, AuthCognitoService]
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: JwtInterceptor,
			multi: true
		}
	],
	bootstrap: [BootstrapComponent]
})
export class AppModule {}
